// src/config/constants.js
export const GAME_PHASES = {
  LOGIN: "LOGIN",
  LOBBY: "LOBBY",
  PRE_GAME_COUNTDOWN: "PRE_GAME_COUNTDOWN",
  CLUE_REVEAL: "CLUE_REVEAL",
  ROLE_REVEAL: "ROLE_REVEAL",
  NIGHT_TRANSITION: "NIGHT_TRANSITION",
  MURDERER_ACTION: "MURDERER_ACTION",
  VICTIM_ACTION: "VICTIM_ACTION",
  ASSISTANT_CONFIRM: "ASSISTANT_CONFIRM",
  DETECTIVE_CONFIRM: "DETECTIVE_CONFIRM",
  CORONER_ACTION: "CORONER_ACTION",
  AGENT_ACTION: "AGENT_ACTION",
  MURDERER_COVERUP: "MURDERER_COVERUP",
  DAY_TRANSITION: "DAY_TRANSITION",
  DISCUSSION: "DISCUSSION",
  VOTING: "VOTING",
  VOTE_RESULT: "VOTE_RESULT",
  GAME_OVER: "GAME_OVER",
};

export const DEFAULT_GAME_MODES = {
  isRandomKillMode: false,
  isBeginnerMode: false,
  discussionTime: 60,
};
